var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCloseCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33317 10.0013C3.33317 13.6771 6.324 16.668 9.99984 16.668C13.6757 16.668 16.6665 13.6771 16.6665 10.0013C16.6665 6.32547 13.6757 3.33464 9.99984 3.33464C6.324 3.33464 3.33317 6.32547 3.33317 10.0013ZM1.6665 10.0013C1.6665 5.4063 5.40484 1.66797 9.99984 1.66797C14.5948 1.66797 18.3332 5.4063 18.3332 10.0013C18.3332 14.5963 14.5948 18.3346 9.99984 18.3346C5.40484 18.3346 1.6665 14.5963 1.6665 10.0013ZM9.99984 8.82297L11.9107 6.91214L13.089 8.09047L11.1782 10.0013L13.089 11.9121L11.9107 13.0905L9.99984 11.1796L8.089 13.0905L6.91067 11.9121L8.8215 10.0013L6.91067 8.09047L8.089 6.91214L9.99984 8.82297Z",
    fill: "#B7B7B7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCloseCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico-close-circle.7740ebefcc9dfdcad2b9c4c1b1d5f918.svg";